'use client';

import type { ReactNode } from 'react';
import { ScrollArea } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';

interface AppScrollAreaProps {
  children: ReactNode;
}

export function AppScrollArea({ children }: AppScrollAreaProps) {
  return (
    <ScrollArea
      type="hover"
      className={styles.scrollArea}
      showHorizontalScrollbar
      aria-label="메인 콘텐츠 영역"
    >
      {children}
    </ScrollArea>
  );
}
